import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banners/banner1.jpg';
import banner2 from '../assets/banners/banner2.jpg';
import banner3 from '../assets/banners/banner3.png';
import pr1 from '../assets/med/pr1.jpg';
import pr2 from '../assets/med/pr2.png';
import pr3 from '../assets/med/pr3.jpg';
import pr4 from '../assets/med/pr4.png';
import pr5 from '../assets/med/pr5.png';
import pr6 from '../assets/med/pr6.png';
import pr7 from '../assets/med/pr7.png';
import pr8 from '../assets/med/pr8.png';

import pr11 from '../assets/med/pr1-1.jpg';
import pr12 from '../assets/med/pr1-2.jpg';
import pr13 from '../assets/med/pr1-3.jpg';
import pr14 from '../assets/med/pr1-4.png';
import pr15 from '../assets/med/pr1-5.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { MdArrowCircleLeft, MdArrowCircleRight } from "react-icons/md";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner1, banner2, banner3];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12 mt-3 mb-3">
								
								<h6
									className="main-section-title font-semi-bold text-dark"
								>
									Medical Gas Outlets
								</h6>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									
								>
									<div className="card-body">
										<img
											style={{
												width: "100%",
												height: "auto",
												
											}}
											src={pr4}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-8 mt-3 mb-3">
								<p
									style={{
										fontSize: "22px"
									}}
								>
									Medical gas outlets are installed at medical gas systems delivery points. Available wall mounting, bed head mounting, and pendant mounting.
								</p>
							</div>

							<div className="col-md-12 mt-3 mb-3">
								<h6
									className="font-bold text-muted"
									style={{
										fontSize: "18px"
									}}
								>
									Product Detail
								</h6>

								British Standard Medical Gas Outlets are installed at medical gas systems delivery points. The base part made of brass alloy. Twice outlet connection. With shut-off valve can maintain without having to interrupt gas delivery to other outlets. Only accept British standard (BS) quick connect adapters. Different gas type with different quick connect adapters.

								<hr/>
							</div>
							

							

							<div className="col-md-12 mt-3 mb-3 d-none">
								<h6
									className="font-bold text-primary text-center"
									style={{
										fontSize: "24px"
									}}
								>
									Related Products
								</h6>

								<div className="row">
									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr11}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Screw Medical Air Compressor
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr12}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Oxygen Tank
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr13}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Refrigeration Air Dryer
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr14}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Oxygen Booster Compressor
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr15}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Cylinder Filling Ramp
													
												</h6>
												
											</div>
											
										</div>
									</div>
								</div>
							</div>
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
